import React, { useCallback, useEffect, useState } from "react";
import api from "../../http";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import { useDispatch, useSelector } from "react-redux";
import { signin, userAuthAction } from "Redux/UserAuthSlice/UserAuthSlice";
import { toast } from "react-toastify";
import { DROP_DOWN_APIS } from "Common/Constants";
import { dataSliceAction } from "Redux/DataSlice/DataSlice";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import { activeSubTab, removePatient, resetTabs, setInsurancePayment } from "Redux/TabsSlice/TabsSlice";
import ConfirmationPopup from "Popups/ConfirmationPopup/ConfirmationPopup";
import { lowercaseKeys } from "Utils/Utils";
import { SWITCH_PRACTICE_SUCCESSFULLY } from "Common/ToastConstants";
import SearchableDropdown from "Common/SearchableDropdown/SearchableDropdown";


const Practices = () => {
  const { practiceDetails } = useSelector((state) => state.userAuth);
  const [allPractices, setAllPractices] = useState([]);
  const [popup, setPopup] = useState(false);
  const [selectedPracticeId, setSelectedPracticeId] = useState('');
  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();


  const handleChange = (value) => {
    setSelectedPracticeId(value);
    if (practiceDetails.id !== value) {
      setPopup(true);
    }
  };

  const handleCancelPopup = () => {
    setPopup(false);
    setSelectedPracticeId(practiceDetails.id);
  };

  const handleSwitchPopup = useCallback(async () => {
    setPopup(false);
    try {
      setLoader(true);
      const insData = {
        paymenttype: "ERA_EOB",
        payerid: "",
        payerName: "",
        checknumber: "",
        checkdatefrom: "",
        checkdateto: "",
        depositdatefrom: "",
        depositdateto: "",
        poststatus: "All",
        entrydatefrom: "",
        entrydateto: "",
        receiveddatefrom: "",
        receiveddateto: "",
        visitid: "",
        posteddatefrom: "",
        posteddateto: "",
        dateType: "Check Date",
      }
      const res = await api.get(`${process.env.REACT_APP_TC_AUTH}/api/Account/SwitchPractice/${selectedPracticeId}`);
      dispatch(signin({
        token: res.data.dataModel.token,
      }));
      dispatch(removePatient());

      const claimSearch = {
        parentKey: 3,
        parentName: 'charges',
        key: 4,
        name: 'search',
        title: 'Search',
        subTabData: {
          visitId: null
        },
        active: true
      }
      dispatch(activeSubTab(claimSearch));

      const userInfo = await api.get(`${process.env.REACT_APP_TC_AUTH}/api/Account/GetUserInfo`)
      const { userModuleRights } = userInfo.data.dataModel.loginUserInfo
      const obj = {
        userInfo: {
          ...userInfo.data.dataModel.loginUserInfo,
          userModuleRights: lowercaseKeys(userModuleRights ?? {}),
          token: res.data.dataModel.token
        },
        practiceDetails: userInfo.data.dataModel.practiceDetails
      }
      dispatch(setInsurancePayment({
        mainTab: "dashboard",
        data: { pID: 0, InsData: insData, rowData: null }
      }))
      // dispatch(swtichTab({ parentName: "dashboard" }))

      dispatch(userAuthAction(obj));

      const promises = DROP_DOWN_APIS.flatMap(apiType => apiType.apis.map(mainApi => api.get(`${apiType.type}/api${mainApi}`)));
      const responses = await Promise.allSettled(promises);
      let keysAndData = {};
      responses.forEach(response => {
        if (response.status === 'fulfilled') {
          let apiUrl = response.value.config.url;
          let keyName = apiUrl.slice(apiUrl.lastIndexOf('/') + 1);
          let data = response.value.data.dataModel;
          keysAndData[keyName] = data
        }
      });
      dispatch(dataSliceAction(keysAndData));
      dispatch(resetTabs())

      localStorage.removeItem("recentSearches");
      toast.success(SWITCH_PRACTICE_SUCCESSFULLY);

      setSelectedPracticeId(selectedPracticeId);
    } catch (error) {
      ErrorHandlingMessage(error);
      setSelectedPracticeId(practiceDetails.id);
    } finally {
      setLoader(false);
    }
  }, [practiceDetails.id, dispatch, selectedPracticeId])

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_TC_AUTH}/api/Account/FindUserAssignedPractices`
        );

        const practices = response.data.dataModel.slice(1);
        setAllPractices(practices);

      } catch (error) {
        ErrorHandlingMessage(error);
      }
    })();
  }, []);
  const handleEnter = useCallback(e => {
    if (e.target.closest('.react-select__control') || e.target.tagName === 'INPUT') {
      return;
    }
    if (e.key === 'Enter' && popup && practiceDetails.id !== selectedPracticeId && !isOpen) {
      handleSwitchPopup();
    }
  }, [handleSwitchPopup, popup, practiceDetails.id, selectedPracticeId, isOpen]);
  useEffect(() => {
    if (!selectedPracticeId) setSelectedPracticeId(practiceDetails.id);
    document.addEventListener('keypress', handleEnter)

    return () => document.removeEventListener('keypress', handleEnter)
    // dispatch(resetTabs())
  }, [handleEnter, practiceDetails.id, selectedPracticeId])

  return (
    <>
      {loader && <FullPageLoader allowFullScreen />}
      {popup && (

        <ConfirmationPopup
          heading="Practice Change"
          subHeading="Are you sure you want to Switch Practice?"
          onConfirm={handleSwitchPopup}
          onCancel={handleCancelPopup}
          buttonTitle="Switch"
        />
      )}
      <SearchableDropdown
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        options={allPractices}
        value={selectedPracticeId}
        onChange={handleChange}
        widthClass="w-full"
        menuWidthClass="w-[320px]"
        containerClassName="w-full"
        controlClassName="h-auto px-2 py-[6px] bg-transparent rounded-[6px] shadow-none hover:bg-[#F3F4F7]"
        menuClassName="mt-1 rounded-[4px] text-[12px] shadow-[0_4px_12px_rgba(0,0,0,0.1)]"
        textClassName="text-[#151A20]"
        tooltipId="sidebar-practice-tooltip"
        triggerVariant="practice"
      />
    </>
  );
};

export default Practices;